import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { Table } from 'components/shared/Table/Table'

export const ActionsCell = ({
  children,
  className,
  maxWidth,
  hasIncreasedHeight,
}) => (
  <Table.Cell type="body" {...{ className, maxWidth, hasIncreasedHeight }}>
    <Box justify="flex-end" tagName="span">
      {children}
    </Box>
  </Table.Cell>
)
